import React,{ useState, useEffect} from 'react';
import { Divider, Loader, Modal, Button } from 'rsuite';
import * as authService from '../../../../app/common/services/fetch.auth.service';
import {  NuInsSmsCodeLabel } from '../elements/inputFieldsLabel';
import {Vector, BackIcon} from '../svg/iconsSvg';
import { SecurityIcon } from "../svg/iconDashSvg";
import CounterButton from '../elements/CounterButton';


const FPVerification = ({onBack, onForward, verificationData, style}) => {

    const [loading, setLoading]   = useState(false);

    const [authRequestId, setAuthRequestId] = useState(verificationData.refNo);

    const [enteredSmsCode, setEnteredSmsCode] = useState('');

    const [showModal, setShowModal] = useState({open: false, text: ''});

    const phone = `+${verificationData.countryCode} ${verificationData.phoneNo}`;

    const goBack = () => onBack(1);

    const goForward = () => onForward(3);

    const focusFirstCodeField = () => {    
        const el = document.getElementById("sms-1");
        if (el) el.focus();
      };

      useEffect(()=> {
        const el = document.getElementById("sms-1");
        if (el) el.focus();
      }, []);

      const closeModal = () => {
        setShowModal({open: false, text: ''});
    }

    const generateSmsCode = async () => {

        setEnteredSmsCode('');

        setLoading(true);

        let res;

        try {
            res = await authService.requestForgottenPasswordChange(phone, verificationData.email);
        } catch (error) {
            console.log(error);
        }

        if(res?.data?.status === 1) {
            if(res?.data?.messageCode === 'INVALID CREDENTIALS') {

                setShowModal({open: true, text: 'Грешен телефонен номер или имеил'})
            } else if (res?.data?.messageCode === "NDF_PHONE_BY_USER_ID") {

                setShowModal({open: true, text: 'Липсват данни за този номер'})
            } else {

                setShowModal({open: true, text: 'Грешка, опитайте отново'});
            }
        } else if (res?.data?.status === 0) {
            const refNo = res?.data?.refNo;
            setAuthRequestId(refNo);
            focusFirstCodeField();
        }

        // console.log(res?.data)  

        setLoading(false)
    }

    const onCodeEnteredHandle = (enteredCode) => {
        if(!enteredCode || enteredCode.length !== 6 ) return;

        setEnteredSmsCode(enteredCode);
    }

    const validateAll = () => {
        return enteredSmsCode.length === 6;
    }

    const submitHandler = async () => {

        if(validateAll()) {
            setLoading(true);

            let res;
    
            try {
                res = await authService.authorizeForgottenPasswordChange(enteredSmsCode, authRequestId, verificationData.password);
            } catch (error) {
                setLoading(false);
                console.log(error);
            }

            if(res?.data?.status === 1) {
                setLoading(false);
                if (res?.data?.messageCode === "INVALID_OTP") {

                    setShowModal({open: true, text: 'Въведеният код е грешен!'})
                } else {
                    setShowModal({open: true, text: 'Грешка, опитайте отново'});
                }
            } else if (res?.data?.status === 0) {
                setLoading(false);

                goForward();
            }
        }
    }

    return (<>
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Забравена парола</h6>
            </div>
            <Divider />
            <div style={{textAlign: 'center', marginTop: '16px', marginBottom: '40px'}}> <Vector /></div>
         
            <h6 className="text-main">{phone}</h6>
            <div className="steps_container-checkbox" style={{justifyContent: 'center',  marginBottom: '40px'}}>
                <SecurityIcon />
                <div>Изпратен е SMS код на този номер </div>
            </div>
        
            <CounterButton onSubmit={generateSmsCode} startWithCountdown={true}/>
       
            <p className="text-main" style={{ alignSelf: "start", paddingLeft: "2rem", fontWeight: '500', marginBottom: '.5rem', marginTop: '40px'}} > Код от SMS </p>  
            
            <NuInsSmsCodeLabel onChange={onCodeEnteredHandle}/>
            
            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" style={{marginTop: '70px'}}
                        disabled={!validateAll()}
                        onClick={submitHandler} >Продължи</button>
        
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
        </div>

        {/* Modal for wrong credential */}
        <Modal size="xs" show={showModal.open} className="nuins-ok-modal" onHide={() => closeModal()}>
            <Modal.Body>
                <p className="no-reg-data" >{showModal.text}</p>    
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => closeModal()} >OK</Button>
            </Modal.Footer>
        </Modal>
     </>
    )
}

export default FPVerification;